// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarAsignatura_main__GjIgi","intro":"ModalEditarAsignatura_intro__+gFZd","input":"ModalEditarAsignatura_input__e-RsC"};